/*eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { axiosInstance } from '../../../../../src/api/axios';
import APIEndpoints from '../../../api/APIEndpoints';
const { Parser } = require('json2csv');

const useDropdown = ({
  data,
  openPDF,
  tableHeader,
  fileName,
  sendEmail,
  userEmail,
  userName,
  emailPDFBody,
  emailCSVBody,
  addressCC,
  addressBCC,
  fromAddress,
}) => {
  const { Email_Configration } = useSelector(
    (state) => state.app?.appConfigs || {},
  );
  const { userData } = useSelector((state) => state.user || {});
  const theme = useSelector((state) => state.theme || {});
  const [countError, setCountError] = useState(0);
  const [loader, setLoader] = useState(0);

  const getCSVTableHeader = () => {
    return tableHeader && Array.isArray(tableHeader)
      ? tableHeader.map((item) => ({ label: item.header, key: item.dataKey }))
      : null;
  };

  const generatePDF = () => {
    const doc = new jsPDF();
    const defaultTableHeader = Object.keys(data[0]).map((item) => ({
      header: item,
      dataKey: item,
    }));
    autoTable(doc, { html: '#my-table' });
    autoTable(doc, {
      theme: 'striped',
      headStyles: {
        fontSize: 8.5,
        fillColor: theme?.themeValuesObject?.['Table-Secondary'],
        textColor: theme?.themeValuesObject?.['Secondary-2'],
      },
      columns: countError ? defaultTableHeader : tableHeader,
      styles: { fontSize: 8.5 },
      body: data,
    });

    return doc;
  };

  const generateCSV = () => {
    const json2csvParser = new Parser();
    let CSVData = {};
    if (countError) {
      CSVData = data;
    } else {
      const arr = [];
      data.map((item) => {
        const obj = {};
        tableHeader.map((innerItem) => {
          obj[innerItem.header] =
            item[innerItem.dataKey] !== undefined
              ? item[innerItem.dataKey]
              : '';
          return obj;
        });
        arr.push(obj);
        return;
      });
      CSVData = arr;
    }

    console.log(CSVData);
    console.log(data);
    const dataCSV = json2csvParser.parse(CSVData);
    return dataCSV;
  };

  const downloadPDF = () => {
    const doc = generatePDF();
    openPDF ? window.open(doc.output('bloburl')) : doc.save(`${fileName}.pdf`);
  };

  const sendPDF = async () => {
    setLoader(true);
    const doc = generatePDF();
    const fileContent = btoa(doc.output());
    emailPDFBody['ToAddress'] = userEmail;
    emailPDFBody['FromAddress'] = Email_Configration.Sender_Email;
    emailPDFBody['ToName'] = userName;
    emailPDFBody['FileContent'] = fileContent;
    emailPDFBody['FileName'] = `${fileName}.pdf`;
    emailPDFBody['FileDescription'] = `${fileName}.pdf`;
    emailPDFBody['CcAddress'] = addressCC;
    emailPDFBody['BccAddress'] = addressBCC;

    try {
      await axiosInstance.post(
        APIEndpoints.getSendEmailResource(),
        emailPDFBody,
      );
      setLoader(false);
      return new Promise((resolve, reject) => {
        resolve('sucess');
      });
    } catch (e) {
      setLoader(false);
      return new Promise((resolve, reject) => {
        reject('Failed');
      });
    }
  };

  const sendCSV = async () => {
    const doc = generateCSV();

    const fileContent = btoa(doc);
    emailCSVBody['ToAddress'] = userEmail;
    emailCSVBody['FromAddress'] = Email_Configration.Sender_Email;
    emailCSVBody['ToName'] = userName;
    emailCSVBody['FileContent'] = fileContent;
    emailCSVBody['FileName'] = `${fileName}.csv`;
    emailCSVBody['FileDescription'] = `${fileName}.csv`;
    emailCSVBody['CcAddress'] = addressCC;
    emailCSVBody['BccAddress'] = addressBCC;

    try {
      await axiosInstance.post(
        APIEndpoints.getSendEmailResource(),
        emailCSVBody,
      );
      setLoader(false);
      return new Promise((resolve, reject) => {
        resolve('sucess');
      });
    } catch (e) {
      setLoader(false);
      return new Promise((resolve, reject) => {
        reject('Failed');
      });
    }
  };

  useEffect(() => {
    if (tableHeader && Array.isArray(tableHeader) && tableHeader.length > 0) {
      tableHeader.map((item) =>
        !Object.keys(item).includes('header') ||
        !Object.keys(item).includes('dataKey')
          ? setCountError(countError + 1)
          : null,
      );
    } else {
      setCountError(countError + 1);
    }
  }, []);

  return {
    downloadPDF,
    sendPDF,
    sendCSV,
    CSVtableHeader: getCSVTableHeader(),
    tableHeaderError: Boolean(countError),
  };
};

export default useDropdown;
